export const email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const URL = /(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)/gim;
export const fullURL = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)/gim;
export const phone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/g;
/** E.164: leading +, then 7–15 digits. Mirrors json-api ListingController isValidPhone. */
export const phoneE164 = /^\+\d{7,15}$/;
/* eslint-disable-next-line */
export const textareaRegex = /(([a-z]+:\/\/)?(([a-z0-9-]+\.)+([a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel|local|internal))(:[0-9]{1,5})?(\/[a-z0-9_\-.~]+)*(\/([a-z0-9_\-.]*)(\?[a-z0-9+_\-.%=&amp;]*)?)?(#[a-zA-Z0-9!$&'()*+.=-_~:@'/?]*)?)(\s+|$)/;
export const WEBSITE = /http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g;
